<p-confirm-dialog [draggable]="false" />
<mon-page-layout [header]="'admin.labels.page.header' | transloco">
    <div subheader data-test="admin-labels-subheader">
        <span>{{ 'admin.labels.page.subHeader' | transloco }}</span>
        @if (!loadingTotal) {
            <span>{{ 'admin.labels.page.subHeaderCount{{availableLabels}}' | transloco: { availableLabels: total } }}</span>
        }
    </div>
    <mon-table-wrapper
            [value]="labels"
            [headers]="[
                TABLE_SCHEMA.LABEL,
                TABLE_SCHEMA.ACTIONS
            ]"
            [total]="paginationTotal"
            [currentPage]="currentPage"
            [perPage]="perPage"
            [loading]="loading"
            [searchText]="searchText"
            [fixedTableLayout]="false"
            [searchPlaceholder]="'admin.labels.page.searchPlaceholder' | transloco"
            [emptyMessage]="'admin.labels.table.emptyMessage' | transloco"
            [emptySearchMessage]="'admin.labels.table.emptySearchMessage' | transloco"
            (searchInput)="onSearchInput($event)"
            (page)="onPageChange($event)"
            tableKey="admin-labels"
            data-test="admin-labels-table">
        <ng-container monTableRight>
            <p-button data-test="admin-labels-add-button"
                      [label]="'admin.labels.page.addLabelBtn.label' | transloco"
                      icon="pi pi-plus"
                      (onClick)="addEditLabel()" />
        </ng-container>
        <span monTableCaption>{{ 'admin.labels.table.description' | transloco }}</span>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.LABEL; let label">
            <div
                class="tw-rounded-md tw-inline-block tw-px-2 tw-py-1"
                [ngStyle]="{
                    color: label.color | adaptiveColor,
                    'background-color': label.color
                }"
            >
                <span class="tw-text-sm tw-font-semibold tw-cursor-default">{{ label.name }}</span>
            </div>
        </ng-container>
        <ng-container *monTableCellTemplate="TABLE_SCHEMA.ACTIONS; let label">
            <p-button
                [ariaLabel]="'admin.labels.table.actionMenuBtn.ariaLabel{{labelName}}' | transloco:{labelName: label.name}"
                data-test="admin-labels-actions-button"
                icon="pi pi-ellipsis-v"
                [rounded]="true"
                [text]="true"
                (onClick)="menu.toggle($event)"
            ></p-button>
            <p-menu
                data-test="admin-labels-actions-menu"
                appendTo="body"
                #menu
                [model]="label.actionItems"
                [popup]="true"
                (onHide)="onMenuHide()"
            >
            </p-menu>
        </ng-container>
    </mon-table-wrapper>
</mon-page-layout>
